<template>
  <div>
    <!-- <div class="mainTitle">考试管理</div> -->

    <el-form
      v-auth="'/exam/search'"
      ref="searchForm"
      :model="searchForm"
      :label-width="formLabelWidth"
      style="background: #fff; border-radius: 4px; padding-top: 20px; padding-right: 20px"
    >
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="6">
          <el-form-item label="所属课程" prop="courseId">
            <!-- <el-input type="number" v-model="searchForm.courseId" auto-complete="off"></el-input> -->
            <el-cascader
              :show-all-levels="false"
              ref="tree"
              @change="subjectChange"
              :options="subjectTreeList"
              :props="subjectTreeProps"
              collapse-tags
              clearable
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-form-item label="考试名称" prop="name">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入考试名称"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-form-item label="试卷类型" prop="type">
            <!-- <el-input v-model="searchForm.type" placeholder="请输入试卷类型" auto-complete="off"></el-input> -->
            <el-select
              style="width: 100%"
              v-model="searchForm.type"
              clearable
              placeholder="请输入试卷类型"
            >
              <el-option
                v-for="item in examType"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="24" :md="12" :lg="4">
          <el-form-item label="状态" prop="type">
            <!-- <el-input v-model="searchForm.type" placeholder="请输入试卷类型" auto-complete="off"></el-input> -->
            <el-select
              style="width: 100%"
              v-model="searchForm.state"
              clearable
              placeholder="请输入状态"
            >
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :sm="24" :md="12" :lg="8">
          <div class="button-Array" style="float:right">
            <a class="mainColor" @click="reset">清空</a>

            <el-button
              type="primary"
              style="border-top-right-radius:0px;border-bottom-right-radius:0px;"
              @click="pageList"
              icon="el-icon-search"
            >查询</el-button>
            <el-button
              type="primary"
              @click="addFormVisible = true"
              style="border-top-left-radius:0px;border-bottom-left-radius:0px;background:rgb(24,200,168);border-color:rgb(24,200,168)"
              icon="el-icon-plus"
            >添加模拟考试</el-button>
          </div>
        </el-col>-->
        <el-col :sm="24" :md="12" :lg="6" style="float: right">
          <!-- <div class="button-Array" style="float:right"> -->
          <!-- <a class="mainColor" @click="reset">清空</a> -->
          <!-- <a class="mainColor" @click="reset">清空</a> -->
          <el-button-group style="float: right">
            <el-button type="primary" @click="pageList" icon="el-icon-search"
              >查询</el-button
            >
            <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
            <el-button type="primary" @click="reset" icon="el-icon-refresh"
              >重置</el-button
            >
            <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
            <el-button
              v-auth="'/exam/addExam'"
              type="primary"
              @click="addFormVisible = true"
              icon="el-icon-plus"
              >添加试卷</el-button
            >
            <!-- <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">添加模拟考试</el-button> -->
          </el-button-group>
        </el-col>
      </el-row>
    </el-form>

    <el-card class="box-card" style="margin-top: 20px">
      <!-- <el-row :span="24">
        <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
          <el-button type="danger" @click="batchDeleteExam" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
          >导出</el-button>
        </el-col>
      </el-row>-->
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        v-loading="Loading"
        @selection-change="selectionChange"
      >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column prop="state" label="状态" width="70">
          <template slot-scope="scope">
            <div class="state">
              <span v-if="scope.row.state == 1" style="background: rgb(24, 200, 168)"
                >上架</span
              >
              <span v-else style="background: rgba(231, 76, 60, 1)">下架</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="courseName"
          width="200"
          label="所属科目"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="type"
          width="200"
          label="试卷类型"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          min-width="200"
          label="考试名称"
        >
          <template slot-scope="scope">
            <!-- <span class="re">[最新]</span>
            <span class="hei">[普通]</span>
            <span class="gr">[免费]</span>
            <span>[付费]</span>-->
            <span class="operItem">{{ scope.row.name }}</span>
            <!-- <i class="iconfont iconxunhuan operItem"></i> -->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="useCount"
          label="使用人数"
          width="90"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.useCount" class="operItem">{{ scope.row.name }}</span>
            <span v-else class="operItem">0</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="score"
          label="总分"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="sort"
          label="排序"
          width="60"
        ></el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="tryUse"
          label="试用"
          width="60"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.tryUse == 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          show-overflow-tooltip
          prop="sort"
          label="试题"
          width="60"
        >
          <template slot-scope="scope">
            <span @click="goQuestion(scope.row.id)" class="mainColor">{{
              scope.row.questionNum || 0
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="视频" width="60">
          <template slot-scope="scope">
            <!-- <div class="add-button" @click="openVideo(scope.row)">查看</div> -->
            <span @click="openVideo(scope.row)" class="mainColor">{{
              scope.row.videoNum || 0
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop
          label="操作"
          fixed="right"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- <span @click="importVisible=true;examId=scope.row.id">导入</span>
              <span >编辑</span>
              <span @click="deleteExam(scope.row)">删除</span>-->
              <i
                v-auth="'/exam/updateExam'"
                class="iconfont iconbianji mainColor"
                @click="
                  selection = scope.row.id;
                  dialogTitle = '编辑试卷';
                  editFormVisible = true;
                "
                title="编辑"
              ></i>
              <!-- <i class="iconfont iconicon7 mainColor" @click="deleteExam(scope.row)" title="删除"></i> -->
              <i
                v-auth="'/exam/import'"
                class="iconfont icondaoru1 mainColor"
                @click="
                  importVisible = true;

                  examId = scope.row.id;
                "
                title="导入"
              ></i>
              <i
                v-auth="'/exam/addExam'"
                class="mainColor el-icon-document-copy"
                @click="
                  selection = scope.row.id;
                  dialogTitle = '复制试卷';
                  editFormVisible = true;
                "
                title="复制"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="!Loading"
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="添加试卷"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      left
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属科目" prop="courseId">
              <el-cascader
                style="width: 100%"
                clearable
                :show-all-levels="false"
                :props="subjectTreeProp"
                placeholder="请输入具体课程"
                v-model="addForm.courseId"
                :options="subjectTreeList"
                @change="subjectChangess"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="评分标准" prop="scoreRuleId">
              <el-select
                style="width: 100%"
                v-model="addForm.scoreRuleId"
                clearable
                placeholder="请输入评分标准"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="试卷类型" prop="type">
              <el-select
                style="width: 100%"
                v-model="addForm.type"
                clearable
                placeholder="请输入试卷类型"
              >
                <el-option
                  v-for="item in examType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="addForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row></el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否上架" prop="state">
              <el-radio-group v-model="addForm.state">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="-1">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否试用" prop="tryUse">
              <el-radio-group v-model="addForm.tryUse">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="-1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="考试名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入考试名称"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addExam">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="50%" left>
      <!-- <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >-->
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="所属科目" prop="courseId">
              <el-cascader
                style="width: 100%"
                clearable
                :show-all-levels="false"
                :props="subjectTreeProp"
                placeholder="请输入具体课程"
                v-model="editForm.courseId"
                :options="subjectTreeList"
                @change="editSubjectChangess"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="评分标准" prop="scoreRuleId">
              <el-select
                style="width: 100%"
                v-model="editForm.scoreRuleId"
                clearable
                :disabled="dialogTitle=='编辑试卷'"
                placeholder="请输入评分标准"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="试卷类型" prop="type">
              <el-select
                style="width: 100%"
                v-model="editForm.type"
                clearable
                placeholder="请输入试卷类型"
              >
                <el-option
                  v-for="item in examType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                type="number"
                v-model="editForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row></el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否上架" prop="state">
              <el-radio-group v-model="editForm.state">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="-1">下架</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否试用" prop="tryUse">
              <el-radio-group v-model="editForm.tryUse">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="-1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="考试名称" prop="name">
              <el-input
                v-model="editForm.name"
                placeholder="请输入考试名称"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateExam">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <!-- <el-upload
        class="upload-demo"
        :action="wordFileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">word点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload> -->
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :headers="reqData"
        :file-list="fileList"
      >
        <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        height="520"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="state" label></el-table-column>
        <el-table-column prop="courseId" label="所属科目"></el-table-column>
        <el-table-column prop="type" label="试卷类型"></el-table-column>
        <el-table-column prop="name" label="考试名称"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button type="primary" @click="importData" icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="视频" :visible.sync="addVideoVisible" width="60%" left>
      <div class="view-video">
        <div class="view-item">
          <span>视频课程:&nbsp;&nbsp;&nbsp;</span>
          <el-select
            v-model="valueData"
            clearable
            @change="listChange"
            placeholder="请选择视频课程"
          >
            <el-option
              v-for="item in videoList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="view-item" style="margin-left: 20px">
          <span>具体视频:&nbsp;&nbsp;&nbsp;</span>
          <el-select
            v-model="valueData1"
            multiple
            collapse-tags
            clearable
            @change="addlistChange"
            placeholder="请选择具体视频"
          >
            <el-option
              v-for="item in addvideoList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <el-button
          v-auth="'/exam/addConcat'"
          size="small"
          style="margin-left: 20px"
          @click="addConcat"
          type="primary"
        >
          <!-- <i class="iconfont icondown" style="margin-top:2px;"></i> -->
          添加绑定
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        v-loading="webLoading"
        :data="examRows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column prop="name" show-overflow-tooltip label="视频名称">
          <template slot-scope="scope">
            <span
              @click="
                playerOptions.sources[0].src = scope.row.url;
                videoDialog = true;
              "
              class="mainColor"
              >{{ scope.row.name }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" prop="url" label="播放" show-overflow-tooltip>
          <template slot-scope="scope">
            <i
              class="iconfont iconziyuan mainColor"
              @click="
                playerOptions.sources[0].src = scope.row.url;
                videoDialog = true;
              "
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" label="操作" width="120">
          <template slot-scope="scope">
            <span class="mainColor" @click="deleteVideo(scope.row.id)">解除绑定</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          v-auth="'/exam/updateChapterVideo'"
          type="primary"
          @click="updateChapterVideo"
          icon="el-icon-document"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importVisible" width="80%" left>
      <Import :exam="examId" v-on:showDiolog="showmessahe"></Import>
    </el-dialog>
    <el-dialog
      title="预览视频"
      :visible.sync="videoDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </el-dialog>
  </div>
</template>

<script>
import Import from "../conmom/import";
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/examView") {
        vm.pageList();
      }
    });
  },
  components: { Import },
  data() {
    return {
      dialogTitle: undefined,
      stateList: [
        {
          label: "上架",
          value: "1",
        },
        {
          label: "全部",
          value: "",
        },
        {
          label: "下架",
          value: "-1",
        },
      ],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      examId: "",
      webLoading: false,
      videoDialog: false,
      Loading: false,
      valueData: "",
      valueData1: [],
      videoList: [],
      examRows: [],
      addvideoList: [],
      addExamForm: {
        examId: "",
        videoInfoIds: "",
      },
      optionsType: [],
      nameArray: [],
      subjectTreeList: [], //科目
      selectedVal_: "",
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      addFormVisible: false,
      addVideoVisible: false,
      editFormVisible: false,
      importVisible: false,
      importFormVisible: false,
      searchForm: {
        courseIds: [],
        name: "",
        type: "",
      },
      addForm: {
        courseId: "",
        scoreRuleId: "",
        type: "",
        name: "",
        sort: "",
        state: "",
        tryUse: "",
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确",
          },
        ],
        scoreRuleId: [
          {
            required: true,
            message: "请输入评分标准",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "评分标准格式不正确",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入试卷类型",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "试卷类型长度在1到255个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "考试名称长度在1到255个字",
          },
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确",
          },
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确",
          },
        ],
        tryUse: [
          {
            required: true,
            message: "请输入是否试用",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否试用格式不正确",
          },
        ],
      },
      editForm: {
        courseId: "",
        scoreRuleId: "",
        type: "",
        name: "",
        sort: "",
        state: "",
        tryUse: "",
      },
      editFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确",
          },
        ],
        scoreRuleId: [
          {
            required: true,
            message: "请输入评分标准",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "评分标准格式不正确",
          },
        ],
        type: [
          {
            required: true,
            message: "请输入试卷类型",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "试卷类型长度在1到255个字",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "考试名称长度在1到255个字",
          },
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确",
          },
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确",
          },
        ],
        tryUse: [
          {
            required: true,
            message: "请输入是否试用",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否试用格式不正确",
          },
        ],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],

      fileAction: `${process.env.BASE_URL}/exam/upload`,
      fileList: [],
      examType: [],
      loading: false,
    };
  },
  methods: {
    closeDialog() {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    showmessahe(data) {
      this.importVisible = data;
      this.pageList();
    },
    deleteVideo(id) {
      this.examRows.forEach((item, index) => {
        if (id == item.id) {
          this.examRows.splice(index, 1);
        }
      });
    },
    updateChapterVideo() {
      let arr = [];
      this.examRows.forEach((item) => {
        arr.push(item.id);
      });
      this.addExamForm.videoInfoIds = arr;
      this.api.exam
        .updateExamVideo(this.addExamForm)
        .then((result) => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message,
            });
            this.addVideoVisible = false;
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addConcat() {
      this.videoArr.forEach((item, index) => {
        let style = true;
        this.examRows.forEach((items, indexs) => {
          if (item.id == items.id) {
            style = false;
          }
        });
        if (style) {
          this.examRows.push(item);
        }
      });
    },
    listChange(val) {
      this.api.videoInfo
        .getVideoInfoList({
          videoCourseId: val,
        })
        .then((result) => {
          if (result.success) {
            this.addvideoList = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addlistChange(val) {
      this.videoArr = [];
      val.forEach((item) => {
        this.addvideoList.forEach((items) => {
          if (item == items.id) {
            this.videoArr.push(items);
          }
        });
      });
      console.log(this.videoArr);
    },
    openVideo(row) {
      this.webLoading = true;
      // 获取已经添加的视频列表
      this.addExamForm.examId = row.id;
      this.api.exam
        .examVideoList({
          examId: row.id,
        })
        .then((result) => {
          if (result.success) {
            this.webLoading = false;
            this.examRows = result.data;
            // this.examRows.forEach(item => {
            //   this.valueData1.push(item.id);
            // });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.api.videoCourse
        .getVideoCourseList({
          courseId: row.courseId,
        })
        .then((result) => {
          if (result.success) {
            this.videoList = result.data;
            this.addVideoVisible = true;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 具体课程change事件
    subjectChangess(val) {
      if (val.length > 0) {
        this.addForm.courseId = val[val.length - 1];
      } else {
        this.addForm.courseId = "";
      }
      this.getScoreRuleSelectListByCourse(this.addForm.courseId);
    },
    editSubjectChangess(val) {
      if (val.length > 0) {
        this.editForm.courseId = val[val.length - 1];
      } else {
        this.editForm.courseId = "";
      }
      this.editForm.scoreRuleId = "";
      this.getScoreRuleSelectListByCourse(this.editForm.courseId);
    },
    getScoreRuleSelectListByCourse(id) {
      this.api.scoreRule
        .getScoreRuleSelectListByCourse({
          courseId: id,
        })
        .then((result) => {
          this.optionsType = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subjectChange(val) {
      this.searchForm.courseIds = [];
      val.forEach((item) => {
        this.searchForm.courseIds.push(item[2]);
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getExam() {
      this.api.exam
        .getExam({
          id: this.selection,
        })
        .then((result) => {
          this.editForm = result.data;
          this.getScoreRuleSelectListByCourse(this.editForm.courseId);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExamTypeList() {
      this.api.examType
        .getExamTypeList({ type: "考试" })
        .then((result) => {
          this.examType = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.Loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.exam
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.Loading = false;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addExam() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          console.info(this.addForm,"this.addForm====");
          if(this.addForm.type == '每日一练' &&
            (this.editForm.sort == null || this.editForm.sort == undefined ||
              this.editForm.sort == 'undefined' || this.editForm.sort == '' ) ){
            this.$message.info("请先填写排序，每日一练类型排序必填")
            return false;
          }
          this.api.exam
            .addExam(this.addForm)
            .then((result) => {
              this.addFormVisible = false;
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateExam() {
      let apiName = undefined;
      if (this.dialogTitle == "编辑试卷") {
        apiName = "updateExam";
      } else {
        apiName = "copyExam";
      }
      if(this.editForm.type == '每日一练' &&
        (this.editForm.sort == null || this.editForm.sort == undefined ||
          this.editForm.sort == 'undefined' || this.editForm.sort == ''  ) ){
        this.$message.info("请先填写排序，每日一练类型排序必填")
        return false;
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.exam[apiName](this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteExam(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.exam
            .deleteExam([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteExam() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.exam
            .deleteExam(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.selectedVal_ = "";
      // this.$refs.tree.setCheckedKeys([]);
      let obj = {};
      try {
        this.$refs.tree.clearValue(obj);
      } catch (err) {
        this.$refs.tree.handleClear(obj);
      }
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.exam
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goQuestion(id) {
      this.$router.push({
        path: "/examView",
        query: {
          examId: id,
        },
      });
    },
    importData() {
      this.api.exam
        .importData(this.importForm.rows)
        .then((result) => {
          this.$message({
            type: "success",
            message: result.message,
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  watch: {
    addVideoVisible(val) {
      if (!val) {
        this.valueData = "";
        this.valueData1 = [];
        this.videoList = [];
        this.examRows = [];
        this.addvideoList = [];
        this.addExamForm = {
          examId: "",
          videoInfoIds: "",
        };
      }
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },

    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getExam();
      }
    },
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
    this.getExamTypeList();
  },
};
</script>
<style lang="less" scoped>
.state {
  span {
    padding: 4px 8px;
    color: #fff;
    border-radius: 4px;
  }
}
.re {
  color: rgb(255, 100, 107);
}
.gr {
  color: rgb(36, 210, 181);
}
.hei {
  color: rgb(162, 170, 188);
}
.view-video {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .view-item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
.el-cascader--small {
  width: 100% !important;
}
.el-icon-document-copy {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/exam/index.vue